import { render, staticRenderFns } from "./merchantForm.vue?vue&type=template&id=6e488f60&scoped=true&"
import script from "./merchantForm.vue?vue&type=script&lang=ts&"
export * from "./merchantForm.vue?vue&type=script&lang=ts&"
import style0 from "./merchantForm.vue?vue&type=style&index=0&id=6e488f60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e488f60",
  null
  
)

export default component.exports